import { render, staticRenderFns } from "./fabric-detail.vue?vue&type=template&id=d892c20e&scoped=true"
import script from "./fabric-detail.vue?vue&type=script&lang=js"
export * from "./fabric-detail.vue?vue&type=script&lang=js"
import style0 from "./fabric-detail.vue?vue&type=style&index=0&id=d892c20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d892c20e",
  null
  
)

export default component.exports